
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const JitsiMeeting = () => {
  // const { roomName } = useParams(); // From route like /meeting/:roomName
  const [token, setToken] = useState("eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InZwYWFzLW1hZ2ljLWNvb2tpZS01YTc4YzQ4MDU2Yzg0OGEzYjJhYzkzMjljY2JiZjI0Yi9lMDAwOGQifQ.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtNWE3OGM0ODA1NmM4NDhhM2IyYWM5MzI5Y2NiYmYyNGIiLCJyb29tIjoibXlSb29tMTIzIiwiZXhwIjoxNzU1MTQ1NDM5LCJuYmYiOjE3NTUxNDE4MzksImNvbnRleHQiOnsidXNlciI6eyJtb2RlcmF0b3IiOnRydWV9LCJmZWF0dXJlcyI6eyJyZWNvcmRpbmciOnRydWUsImxpdmVzdHJlYW1pbmciOmZhbHNlLCJ0cmFuc2NyaXB0aW9uIjpmYWxzZX19fQ.ZfO2DCNIzWmmqmHS4phW3Y8CL3KXioBbu7h1PU0K9WFldSEUIsPKlZcPvOyc4hGPWi0iApGm5G3OrVnOZr_gEoJFKeagmoL4tECE9t0xnNHtaRXgRksprNPbZh10gF3gqF6xdlxd-38ff9YmEHhDvOiVcgZVC-6sviiSVhz9FlqxS2LDlBxnK5qMqpxzL23FxRTKPbZHsuXVn7dSd37gmajtVNYujbgp7esi5knQkruZ0thCfVwUn0mBOn6ke4DlMcHBNGj4hAOYiIzlh_iNdoUqAoZb3cp0k-i5Gh2ynLcFuN9JYv2rDEss2XE06ItWXVFyGgC8H2yh9ewqNkaonQ");
const roomName = "vpaas-magic-cookie-5a78c48056c848a3b2ac9329ccbbf24b/myRoom123";



  // useEffect(() => {
  //   // 1️⃣ Fetch token from backend
  //   const fetchToken = async () => {
  //     try {
  //       const res = await fetch("http://localhost:5000/api/Meeting/generate-token");
  //       const data = await res.json();
  //       setToken(data.token);
  //     } catch (err) {
  //       console.error("Error fetching token:", err);
  //     }
  //   };

  //   fetchToken();
  // }, []);

  useEffect(() => {
    if (!token) return;

    // 2️⃣ Load Jitsi API
    const loadJitsiScript = () => {
      if (window.JitsiMeetExternalAPI) {
        createMeeting();
      } else {
        const script = document.createElement("script");
        script.src = "https://8x8.vc/external_api.js"; // JaaS URL
        script.async = true;
        script.onload = () => createMeeting();
        document.body.appendChild(script);
      }
    };

    // 3️⃣ Create meeting with JWT
    const createMeeting = () => {
      const domain = "8x8.vc"; // JaaS domain
      const options = {
        roomName:roomName, // appId/roomName
        jwt: token, // Pass JWT here
        width: "100%",
        height: 600,
        parentNode: document.getElementById("jitsi-container"),
        configOverwrite: {},
        interfaceConfigOverwrite: {}
      };

      new window.JitsiMeetExternalAPI(domain, options);
    };

    loadJitsiScript();
  }, [token, roomName]);

  return (
    <div>
      <h2>Meeting Room: {roomName}</h2>
      {!token && <p>Loading meeting...</p>}
      <div id="jitsi-container" />
    </div>
  );
};

export default JitsiMeeting;

